<template>
    <div class="ui-timeline-card">
        <div class="avatar">
            <ui-image :src="getImgCDN(value.user_photo)" alt="teste" design="circle border-lg" h="45" w="45" />
        </div>
        <div class="content">
            <div class="title" @click="toggle">
                <div>{{ value.user_name }} - <span> {{ groupComputed }}</span></div>
                <div>
                    <i class="fas" :class="textShow ? 'fa-caret-up' : 'fa-caret-down' "></i>
                </div>
            </div>
            <div class="text wrapword" v-if="textShow" v-html="value.message"/>
            <div class="client-infos" v-if="textShow" @click="oldPanelLinkButton('vendas/negocios/' + value.deal_id)">
                <div class="name">Cliente: {{ value.customer }}</div>
                <div class="code">
                    <ui-tag-indicator color="#4BB478" :text="'Nº ' + value.deal_id" />
                </div>
            </div>
            <div class="date">
                <i class="fal fa-calendar-alt"></i> Data: {{ value.created_at | moment("DD/MM/YYYY [às] H:m") }}
            </div>
        </div>
    </div>
</template>

<script>
    import { uiTagIndicator } from '@/components/ui/tags'
    import { uiImage } from '@/components/ui'
    import { facilita } from '@/global'
    import helpers from '@/mixins/helpers'
    export default {
        name: 'ui-timelinecard',
        components: { uiTagIndicator, uiImage },
        mixins: [helpers],
		props:{
            value: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            }
		},
		data() {
            return {
                textShow: true
                
            }
        },
        computed: {
            groupComputed: {
                get() {
                    switch (this.value.user_group) {
                        case 'broker':
                            return 'Corretor'
                        default:
                            return this.value.user_group
                    }
                }
            }
        },
        methods: {
            toggle(){
                this.textShow = !this.textShow
            },

            open(){
                window.location.href = facilita.panel + '/vendas/negocios/' + this.value.deal_id
            }
            
        }
		
	};
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
    .wrapword {
        white-space: -moz-pre-wrap !important;  /* Mozilla, since 1999 */
        white-space: -pre-wrap;      /* Opera 4-6 */
        white-space: -o-pre-wrap;    /* Opera 7 */
        white-space: pre-wrap;       /* css-3 */
        word-wrap: break-word;       /* Internet Explorer 5.5+ */
        white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
        word-break: break-all;
        white-space: normal;
    }
</style>
